<template>
  <v-container fluid>
    <!-- <v-card style="margin-bottom: 20px;">
      <v-card-title>Deployments</v-card-title>
      <v-card-text>
        <p>
          Deployments are how Organizations and Applications can allow Users to
          view certain data for a certain amount of time. Deployments have User
          Access, meaning Organizations can set who has access to events for a
          device during a specific deployment. A deployment has a start date,
          and once the deployment is finished it will have a end date. This
          means users that had access to the events for that deployment, will
          still be able to view those events once the deployment has concluded.
        </p>
      </v-card-text>
    </v-card>-->
    <v-card :loading="deploymentsLoading">
      <v-toolbar color="primary" dark>
        Deployments
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon dark v-bind="attrs" v-on="on">mdi-information-variant</v-icon>
          </template>
          <p>
            Deployments are how Organizations and Applications can allow Users
            to view certain data for a certain amount of time. Deployments have
            User Access, meaning Organizations can set who has access to events
            for a device during a specific deployment. A deployment has a start
            date, and once the deployment is finished it will have a end date.
            This means users that had access to the events for that deployment,
            will still be able to view those events once the deployment has
            concluded.
          </p>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchDeployments"
          label="Search"
          single-line
          hide-details
          prepend-icon="mdi-magnify"
          clearable
          v-on:input="onQuickFilterChanged()"
        ></v-text-field>
      </v-toolbar>
      <expandedToolbar :newButton="true" @newButtonClick="newDeploymentDialog = true" />
      <v-card-text v-if="deployments">
        <v-row>
          <v-col style="height: calc(100vh - 230px) !important;" cols="12">
            <ag-grid-vue
              :style="{ width, height }"
              class="ag-theme-alpine"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :rowData="rowData"
              :animateRows="true"
              rowSelection="multiple"
              @grid-ready="onGridReady"
              @cellDoubleClicked="onCellDoubleClick"
            ></ag-grid-vue>
          </v-col>
        </v-row>
        <!-- <v-data-table
          :headers="deploymentsHeaders"
          :items="deployments"
          :search="searchDeployments"
          :items-per-page="10"
          item-key="name"
          sort-by="id"
          :sort-desc="true"
          class="elevation-0"
          :loading="deploymentsLoading"
        >
          

          <template v-slot:item.actions="{ item }">
            <div>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-if="!item.end_ts" @click="endDeployment(item)">
                    <v-list-item-title>End Deployment</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-data-table>-->
      </v-card-text>
    </v-card>
    <v-dialog v-model="manageDeploymentDialog" persistent max-width="600px">
      <v-card v-if="deployments" tile>
        <v-toolbar color="primary" dark>
          Manage Deployment
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            icon
            dark
            @click="
              manageDeploymentDialog = false;
              deploymentFormData = {};
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="deploymentFormData.name" label="Deployment Name"></v-text-field>
              </v-col>
              <!-- <v-col v-if="applications" cols="12">
                <v-select
                  v-model="deploymentFormData.applications_id"
                  :items="applications"
                  :rules="[value => !!value || 'Application is Required.']"
                  item-text="name"
                  item-value="id"
                  label="Application"
                  required
                ></v-select>
              </v-col>-->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="manageDeploymentLoading" @click="saveDeployment()" color="success">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newDeploymentDialog" persistent max-width="600px">
      <v-card v-if="deployments" tile>
        <v-toolbar color="primary" dark>
          New Deployment
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="newDeploymentDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="selectedOrgID"
                  :items="organizations"
                  :rules="[value => !!value || 'Organization is Required.']"
                  item-text="name"
                  item-value="id"
                  label="Organization"
                  @change="filterOwnerships"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  :disabled="!ownershipsFiltered"
                  v-model="deploymentFormData.ownership_id"
                  :items="filteredOwnerships"
                  :rules="[value => !!value || 'Ownership is Required.']"
                  item-text="devices_id"
                  item-value="id"
                  label="Device"
                  required
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="newDeploymentLoading"
            @click="generateNewDeployment()"
            color="success"
          >Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="aGGridActionMenu" persistent max-width="300px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Action Menu
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="updateAGGridActionMenu()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-list v-if="selectedRowData" dense>
                  <!-- <v-list-item :to="'/dashboard'">
                    <v-list-item-action>
                      <v-icon>mdi-account-box</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Event Profile</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>-->
                  <v-list-item @click="viewDeploymentDetails()">
                    <v-list-item-action>
                      <v-icon>mdi-information-variant</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>View Details</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="openUserSearch()">
                    <v-list-item-action>
                      <v-icon>mdi-account-plus</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Add User to Deployment</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="!selectedRowData.end_ts" @click="endDeployment()">
                    <v-list-item-action>
                      <v-icon>mdi-block-helper</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>End Deployment</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="viewDetailsDialog" persistent max-width="600px">
      <v-card tile>
        <v-toolbar :color="getDeploymentColor(selectedRowData.end_ts)" dark>
          Deployment #{{ selectedRowData.id }}
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="viewDetailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Deployment Name</p>
                <p class="mb-0">Comming Soon!</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Deployment Status</p>
                <p v-if="selectedRowData.end_ts" style="color: red;" class="mb-0">Finished</p>
                <p v-else color="green" style="color: green;" class="mb-0">Active</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Deployment Start</p>
                <p class="mb-0">{{ selectedRowData.start_ts }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Deployment End</p>
                <p class="mb-0">{{ selectedRowData.end_ts }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Device ID</p>
                <p class="mb-0">{{ selectedRowData.devices_id }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Applications Name</p>
                <p class="mb-0">{{ selectedRowData.applications_name }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Organizations Name</p>
                <p class="mb-0">{{ selectedRowData.organizations_name }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="pb-0 mb-0 font-weight-black">Events Count</p>
                <p class="mb-0">{{ selectedRowData.eventsCount }}</p>
              </v-col>
              <v-col cols="12">
                <!-- TODO: Add proper Security -->
                <p
                  class="pb-0 mb-0 font-weight-black"
                >Users ({{ selectedRowData.usersAccessCount }})</p>
                <div v-if="!deploymentUsersLoading" class="mb-0">
                  <p :key="i" v-for="(item, i) in deploymentUsers">{{ item.name }} {{item.email}}</p>
                </div>
                <v-skeleton-loader
                  v-else
                  ref="skeleton"
                  :boilerplate="false"
                  :type="'list-item-avatar-two-line'"
                  :tile="false"
                  class="mx-auto"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <userSearch
      :show="searchUserShow"
      :selectedRowData="selectedRowData"
      :filterByField="'deploymentsAccessOf'"
      @closeSearch="searchUserShow = false"
      @addUser="grantUserAccess"
    />
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";
  import agGridActionButton from "@/components/agGridActionButton";
  import expandedToolbar from "@/components/expandedToolbar.vue";
  import userSearch from "@/components/userSearch.vue";
  import { AgGridVue } from "ag-grid-vue";
  import moment from "moment";

  export default {
    components: {
      AppBar,
      AgGridVue,
      agGridActionButton,
      expandedToolbar,
      userSearch,
    },
    computed: {
      ...mapGetters([
        "currentUser",
        "currentUserData",
        "aGGridActionMenu",
        "selectedRowData",
        "deployments",
        "deploymentsLoading",
        "ownerships",
        "ownershipsLoading",
        "organizations",
        "organizationsLoading",
        "deploymentUsersLoading",
        "deploymentUsers",
      ]),
    },
    props: {
      source: String,
    },
    data: () => ({
      searchUserShow: false,
      // AG-Grid
      columnDefs: null,
      rowData: null,
      columnApi: null,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        autoHeight: true,
      },
      width: "100%",
      height: "100%",

      drawer: null,
      deploymentsHeaders: [
        {
          text: "ID",
          align: "left",
          sortable: true,

          value: "id",
          width: "80px",
        },
        {
          text: "Start",
          value: "start_ts",
        },
        {
          text: "End",
          value: "end_ts",
        },
        {
          text: "Ownership ID",
          value: "ownership_id",
        },
        {
          text: "Device ID",
          value: "devices_id",
        },
        {
          text: "Org ID",
          value: "organizations_id",
        },
        {
          text: "Org Name",
          value: "organizations_name",
        },
        {
          text: "App ID",
          value: "applications_id",
        },
        {
          text: "App Name",
          value: "applications_name",
        },
        {
          text: "App Prefix",
          value: "applications_prefix",
        },
        {
          text: "Users",
          value: "usersAccessCount",
        },
        {
          text: "Events",
          value: "eventsCount",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
      searchDeployments: "",
      //New Deployments
      newDeploymentDialog: false,
      newDeploymentLoading: false,
      //Manage Deployments
      manageDeploymentDialog: false,
      manageDeploymentLoading: false,
      //DeploymentFormData
      deploymentFormData: {},

      selectedOrgID: null,
      ownershipsFiltered: false,
      filteredOwnerships: [],

      // Selected Deployment Details
      viewDetailsDialog: false,
    }),
    beforeMount() {
      this.columnDefs = [
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "agGridActionButton",
        },
        {
          headerName: "ID",
          field: "id",
        },
        {
          headerName: "Start",
          field: "start_ts",
        },
        {
          headerName: "End",
          field: "end_ts",
        },
        {
          headerName: "Ownership ID",
          field: "ownership_id",
        },
        {
          headerName: "Device ID",
          field: "devices_id",
        },
        {
          headerName: "Org Name",
          field: "organizations_name",
        },
        {
          headerName: "App Name",
          field: "applications_name",
        },
        {
          headerName: "Users",
          field: "usersAccessCount",
        },
        {
          headerName: "Events",
          field: "eventsCount",
        },
      ];
      this.$store.dispatch("loadDeployments").then(() => {
        this.rowData = this.deployments;
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.columnApi.autoSizeColumns(allColumnIds, false);
      });
      if (this.aGGridActionMenu == true) {
        this.$store.dispatch("setAGGridActionMenuState", {});
      }
    },
    mounted() {
      this.$store.dispatch("loadOwnerships");
      this.$store.dispatch("loadOrganizations");
      // To demonstrate functionality of exposed component functions
      // Here we make focus on the user input
      // this.$refs.address.focus();
    },
    watch: {
      deployments: function (oldDep, newDep) {
        this.rowData = this.deployments;
      },
    },
    methods: {
      onQuickFilterChanged() {
        this.gridApi.setQuickFilter(this.searchDeployments);
      },
      onGridReady(params) {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
      },
      autoSizeColumnsAGGRID() {
        // this.gridApi.sizeColumnsToFit();
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.columnApi.autoSizeColumns(allColumnIds, false);
      },
      onCellDoubleClick(cell) {
        this.$store.dispatch("setSelectedRowData", cell.data);
        this.viewDeploymentDetails();
      },
      updateAGGridActionMenu() {
        this.$store.dispatch("setAGGridActionMenuState", {});
      },
      filterOwnerships() {
        this.ownershipsFiltered = false;
        let org = this.organizations.find((o) => o.id == this.selectedOrgID);
        let owners = this.ownerships.filter(
          (ow) =>
            ow.organizations_id == org.id &&
            ow.activeDeployment == "0" &&
            !ow.end_ts
        );
        this.filteredOwnerships = owners;
        this.ownershipsFiltered = true;
      },
      generateNewDeployment() {
        this.newDeploymentLoading = true;
        this.$store
          .dispatch("newDeployment", this.deploymentFormData)
          .then((result) => {
            this.newDeploymentLoading = false;
            this.newDeploymentDialog = false;
            this.$swal({
              title: "Success!",
              text: `Deployment has been Created`,
              type: "success",
              confirmButtonText: "Ok",
            });
            this.selectedOrgID = null;
            this.deploymentFormData = {};
          });
      },
      endDeployment() {
        this.$store
          .dispatch("endDeployment", this.selectedRowData)
          .then((result) => {
            this.updateAGGridActionMenu();
            this.$swal({
              title: "Success!",
              text: `The Deployment has been concluded.`,
              type: "success",
              confirmButtonText: "Ok",
            });
          });
      },
      openUserSearch() {
        this.searchUserShow = true;
      },
      grantUserAccess(user) {
        let payload = {
          users_id: user,
          deployments_id: this.selectedRowData.id,
        };
        this.searchUserShow = false;
        this.updateAGGridActionMenu();
        this.$store
          .dispatch("grantUserDeploymentAccess", payload)
          .then((result) => {
            this.$swal({
              title: "Success!",
              text: `This User was granted Access to this deployment`,
              type: "success",
              confirmButtonText: "Ok",
            });
          });
      },
      viewDeploymentDetails() {
        this.viewDetailsDialog = true;
        this.$store.dispatch("loadDeploymentUsers", this.selectedRowData.id);
      },
      getDeploymentColor(end_ts) {
        let color = "primary";
        switch (!end_ts) {
          case true:
            color = "green";
            break;
          case false:
            color = "red";
            break;
          default:
            break;
        }
        return color;
      },
      // openManageDeployment(item) {
      //   this.deploymentFormData = {
      //     id: item.id,
      //     name: item.name,
      //     applications_id: item.applications_id
      //   };
      //   this.manageDeploymentDialog = true;
      // },
      // saveDeployment() {
      //   this.manageDeploymentLoading = true;
      //   this.$store
      //     .dispatch("saveDeployment", this.deploymentFormData)
      //     .then(result => {
      //       this.manageDeploymentLoading = false;
      //       this.manageDeploymentDialog = false;
      //       this.$swal({
      //         title: "Success!",
      //         text: `${this.deploymentFormData.name} was Saved`,
      //         type: "success",
      //         confirmButtonText: "Ok"
      //       });
      //       this.deploymentFormData = {};
      //     });
      // }
    },
  };
  window.batteryFormatter = function batteryFormatter(params) {
    if (params.data.battery) {
      return `${params.data.battery}V`;
    } else {
      return "";
    }
  };
  window.temperatureFormatter = function temperatureFormatter(params) {
    if (params.data.temp) {
      return params.data.temp + "°c";
    } else {
      return "";
    }
    return params.data.temp + "°c";
  };
  window.createdAtFormatter = function createdTimeFormatter(params) {
    return moment
      .utc(params.data.created_at)
      .local()
      .format("MMMM Do YYYY, h:mm:ss a");
  };
  window.updatedAtFormatter = function createdTimeFormatter(params) {
    if (params.data.updated_at) {
      return moment
        .utc(params.data.updated_at)
        .local()
        .format("MMMM Do YYYY, h:mm:ss a");
    } else {
      return "";
    }
  };
</script>
